var jacketVariantTokens = {
  'primary.deals': {
    backgroundColor: 'product.day-use',
    textColor: 'base.inverted'
  },
  'primary.intense': {
    backgroundColor: 'feedback.negative',
    textColor: 'base.inverted'
  },
  'primary.neutral': {
    backgroundColor: 'base.surface.floating.inverted',
    textColor: 'base.inverted'
  },
  'primary.notice': {
    backgroundColor: 'feedback.notice',
    textColor: 'base.inverted'
  },
  'primary.positive': {
    backgroundColor: 'feedback.positive',
    textColor: 'base.inverted'
  },
  'primary.urgency': {
    backgroundColor: 'feedback.urgent',
    textColor: 'base.inverted'
  },
  'secondary.deals': {
    backgroundColor: 'product.day-use.subtle',
    textColor: 'product.day-use'
  },
  'secondary.intense': {
    backgroundColor: 'feedback.negative.subtle',
    textColor: 'feedback.negative'
  },
  'secondary.neutral': {
    backgroundColor: 'base.background',
    textColor: 'base.default'
  },
  'secondary.notice': {
    backgroundColor: 'feedback.notice.subtle',
    textColor: 'feedback.notice'
  },
  'secondary.positive': {
    backgroundColor: 'feedback.positive.subtle',
    textColor: 'feedback.positive'
  },
  'secondary.urgency': {
    backgroundColor: 'feedback.urgent.subtle',
    textColor: 'feedback.urgent'
  }
};

export { jacketVariantTokens };
//# sourceMappingURL=Jacket.mappers.js.map
